import React, { useEffect } from 'react';
import PullToRefresh from 'pulltorefreshjs';
import ReactDOMServer from 'react-dom/server';

const refreshStyles = `
.__PREFIX__ptr {
  pointer-events: none;
  font-size: 0.85em;
  font-weight: bold;
  top: 0;
  height: 0;
  transition: height 0.3s, min-height 0.3s;
  text-align: center;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  align-content: stretch;
}
.__PREFIX__box {
  padding: 10px;
  flex-basis: 100%;
}
.__PREFIX__pull {
  transition: none;
}
.__PREFIX__text {
  margin-top: .33em;
  color: rgba(0, 0, 0, 0.3);
}
.__PREFIX__icon {
  color: rgba(0, 0, 0, 0.3);
  transition: transform .3s;
}
/*
When at the top of the page, disable vertical overscroll so passive touch
listeners can take over.
*/
.__PREFIX__top {
  touch-action: pan-x pan-down pinch-zoom;
}
.__PREFIX__release .__PREFIX__icon {
  transform: rotate(180deg);
}
`;

const refreshMarkup = `
  <div class="__PREFIX__box">
    <div class="__PREFIX__content">
      <div class="__PREFIX__icon"></div>
    </div>
  </div>
`;

const usePullToRefresh = (
  mainElementClass: string,
  loadingComponent: React.ReactElement,
  loadFunction: () => void,
  useDefaultScrollDetector: boolean = false
) => {
  useEffect(() => {
    PullToRefresh.init({
      mainElement: mainElementClass,
      triggerElement: mainElementClass,
      onRefresh() {
        console.log('On Refresh');
        loadFunction();
      },
      instructionsPullToRefresh: '',
      instructionsReleaseToRefresh: '',
      instructionsRefreshing: '',
      iconRefreshing: ReactDOMServer.renderToString(loadingComponent),
      iconArrow: ReactDOMServer.renderToString(loadingComponent),
      distReload: 84,
      getStyles: () => refreshStyles,
      getMarkup: () => refreshMarkup,
      refreshTimeout: 700,
      shouldPullToRefresh: function () {
        if (useDefaultScrollDetector) {
          return window.scrollY === 0;
        }
        return document.querySelector(mainElementClass).scrollTop === 0;
      },
    });
    return () => {
      PullToRefresh.destroyAll();
    };
  }, [mainElementClass, loadFunction, loadingComponent]);
};

export default usePullToRefresh;
